import { render } from "./orders-table.vue?vue&type=template&id=0809ab1c&ts=true"
import script from "./orders-table.vue?vue&type=script&lang=ts"
export * from "./orders-table.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__